import { render, staticRenderFns } from "./variable-funding-viewer-summary-header.vue?vue&type=template&id=21bac8b9&scoped=true"
import script from "./variable-funding-viewer-summary-header.vue?vue&type=script&lang=js"
export * from "./variable-funding-viewer-summary-header.vue?vue&type=script&lang=js"
import style0 from "./variable-funding-viewer-summary-header.vue?vue&type=style&index=0&id=21bac8b9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21bac8b9",
  null
  
)

export default component.exports